import React from 'react';

/**
 * Simple Loading Spinner Component
 * Pure CSS spinner without external dependencies
 */
const LoadingSpinner = ({ 
  message = "Loading...", 
  size = "large",
  fullscreen = false,
  delay = 0 
}) => {
  const spinnerSize = size === 'large' ? 48 : 24;
  const borderWidth = size === 'large' ? 4 : 2;

  const spinnerStyle = {
    width: spinnerSize,
    height: spinnerSize,
    border: `${borderWidth}px solid var(--color-border-light)`,
    borderTop: `${borderWidth}px solid var(--color-primary)`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    display: 'inline-block'
  };

  const content = (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'var(--spacing-md)',
    }}>
      <div style={spinnerStyle} />
      {message && (
        <div style={{
          color: 'var(--color-text-secondary)',
          fontSize: 'var(--text-sm)',
          textAlign: 'center',
        }}>
          {message}
        </div>
      )}
    </div>
  );

  if (fullscreen) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--color-bg-overlay)',
        zIndex: 9999
      }}>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
        {content}
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--spacing-xl) var(--spacing-lg)',
      minHeight: '200px'
    }}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      {content}
    </div>
  );
};

export default LoadingSpinner;
